import { render, staticRenderFns } from "./userPermissions.vue?vue&type=template&id=7a5e2240&"
import script from "./userPermissions.vue?vue&type=script&lang=js&"
export * from "./userPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports